import { css } from "@emotion/react";
import styled from "@emotion/styled";
import type { ThemeType } from "scmp-sdk/components/newsletter/newsletter-widget/types";

import { theme as breakpointTheme } from "shared/lib/styles";

export const theme = {
  findOutMore: {
    titleFontStyle: "small",
  },
  hasSummaryLine: false,
  newsletterIcon: {
    icon: "black",
  },
  orientation: "landscape",
  root: {
    containerSize: "medium",
    customCss: css`
      max-inline-size: 100%;
      ${breakpointTheme.breakpoints.up("desktop")} {
        max-inline-size: 100%;
      }
    `,
  },
} as ThemeType;

export const Container = styled.div`
  inline-size: 100%;
  padding-block: 20px;

  border-block-start: 1px solid #727272;

  background: #ffffff;
`;
